/**
 * Custom DOM event dispatched by cart-mutating client components (add to
 * cart, quantity change, item removal) so `CartProvider` — which otherwise
 * only fetches once on layout mount — knows to refetch. Without this, e.g.
 * the header's mini-cart dropdown keeps showing pre-mutation quantities
 * until the next full page load, since it holds no server-fetched cart data
 * of its own.
 *
 * Kept in its own dependency-free module (mirrors
 * `@lib/analytics/constants`'s event names) so dispatchers only need this
 * string — importing it from `cart-provider/index.tsx` directly would pull
 * in that file's `getLayoutSnapshot` Server Action dependency for no reason.
 */
export const CART_CHANGED_EVENT = 'medusa:cartchanged';
